export const chenbroProducts = [
  // ========== 1U SERIES ==========
  {
    id: `rm13304`,
    name: { de: `RM13304`, en: `RM13304`, es: `RM13304` },
    description: {
      de: `1U Storage-Server-Chassis mit 4x 3.5 Zoll Hot-Swap-Fächern, 12Gbps SAS/SATA Backplane und Unterstützung für E-ATX Mainboards in professionellen Storage- und Backup-Umgebungen.`,
      en: `1U storage server chassis with 4x 3.5 inch hot-swap bays, 12Gbps SAS/SATA backplane, and E-ATX motherboard support for professional storage and backup deployments.`,
      es: `Chasis de servidor 1U para almacenamiento con 4 bahías hot-swap de 3.5 pulgadas, backplane SAS/SATA de 12Gbps y soporte para placas E-ATX en entornos profesionales de storage y backup.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `1U | 4x 3.5 Hot-Swap | 12Gbps SAS/SATA | E-ATX | 1U RPSU`,
    images: [
      `/images/products/chenbro/rm13304.jpg`,
      `/images/products/chenbro/rm13304-front.jpg`,
      `/images/products/chenbro/rm13304-up.jpg`,
      `/images/products/chenbro/rm13304-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm13304.pdf`,
    price: null
  },
  {
    id: `rm13310-sas`,
    name: { de: `RM13310 (SAS/SATA)`, en: `RM13310 (SAS/SATA)`, es: `RM13310 (SAS/SATA)` },
    description: {
      de: `1U Server-Chassis mit 10x 2.5 Zoll Hot-Swap-Fächern, SAS/SATA Backplane und E-ATX Mainboard-Unterstützung für dichte Storage- und Virtualisierungsinstallationen.`,
      en: `1U server chassis with 10x 2.5 inch hot-swap bays, SAS/SATA backplane, and E-ATX motherboard support for dense storage and virtualization deployments.`,
      es: `Chasis de servidor 1U con 10 bahías hot-swap de 2.5 pulgadas, backplane SAS/SATA y soporte para placas E-ATX en implementaciones densas de almacenamiento y virtualización.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `1U | 10x 2.5 Hot-Swap | SAS/SATA | E-ATX | 1U RPSU`,
    images: [
      `/images/products/chenbro/rm13310-sas-sata.jpg`,
      `/images/products/chenbro/rm13310-sas-sata-front.jpg`,
      `/images/products/chenbro/rm13310-sas-sata-up.jpg`,
      `/images/products/chenbro/rm13310-sas-sata-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm13310-sas.pdf`,
    price: null
  },
  {
    id: `rm13310-nvme`,
    name: { de: `RM13310 (NVMe)`, en: `RM13310 (NVMe)`, es: `RM13310 (NVMe)` },
    description: {
      de: `1U High-Performance Server-Chassis mit 10x 2.5 Zoll Hot-Swap-Fächern und NVMe Backplane für latenzkritische Storage- und Compute-Workloads.`,
      en: `1U high-performance server chassis with 10x 2.5 inch hot-swap bays and NVMe backplane for latency-sensitive storage and compute workloads.`,
      es: `Chasis de servidor 1U de alto rendimiento con 10 bahías hot-swap de 2.5 pulgadas y backplane NVMe para cargas de storage y cómputo sensibles a la latencia.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `1U | 10x 2.5 Hot-Swap | NVMe | E-ATX | 1U RPSU`,
    images: [
      `/images/products/chenbro/rm13310-nvme.jpg`,
      `/images/products/chenbro/rm13310-nvme-front.jpg`,
      `/images/products/chenbro/rm13310-nvme-up.jpg`,
      `/images/products/chenbro/rm13310-nvme-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm13310-nvme.pdf`,
    price: null
  },
  {
    id: `rm14604-plus`,
    name: { de: `RM14604 Plus`, en: `RM14604 Plus`, es: `RM14604 Plus` },
    description: {
      de: `1U kompaktes Server-Chassis mit 4x 3.5 Zoll Hot-Swap, 2x internen 2.5 Zoll, 1x Slim ODD, ATX-Mainboard-Support und modularem 1U-Netzteilkonzept für SMB- und Edge-Installationen.`,
      en: `1U compact server chassis with 4x 3.5 inch hot-swap bays, 2x internal 2.5 inch bays, 1x slim ODD, ATX motherboard support, and a modular 1U PSU design for SMB and edge deployments.`,
      es: `Chasis de servidor 1U compacto con 4 bahías hot-swap de 3.5 pulgadas, 2 internas de 2.5 pulgadas, 1 Slim ODD, soporte para placa ATX y diseño modular de fuente 1U para entornos SMB y edge.`
    },
    category: `Rackmount Chassis`,
    application: `cloud`,
    specs: `1U | 4x 3.5 Hot-Swap + 2x 2.5 Int + Slim ODD | 12Gbps SAS/SATA | ATX 12x9.6 | 1U Single/1+1`,
    images: [
      `/images/products/chenbro/rm14604-plus.jpg`,
      `/images/products/chenbro/rm14604-plus-front.jpg`,
      `/images/products/chenbro/rm14604-plus-up.jpg`,
      `/images/products/chenbro/rm14604-plus-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm146-series.pdf`,
    price: null
  },
  {
    id: `rm14610-plus`,
    name: { de: `RM14610 Plus`, en: `RM14610 Plus`, es: `RM14610 Plus` },
    description: {
      de: `1U Storage-Server-Chassis mit 10x 2.5 Zoll Hot-Swap, optional 2x internen 2.5 Zoll, 12Gbps Mini-SAS HD Backplane und ATX-Support für platzsparende Rechenzentrumsinstallationen.`,
      en: `1U storage server chassis with 10x 2.5 inch hot-swap bays, optional 2x internal 2.5 inch bays, 12Gbps mini-SAS HD backplane, and ATX support for space-efficient data center deployments.`,
      es: `Chasis de servidor 1U para almacenamiento con 10 bahías hot-swap de 2.5 pulgadas, opción de 2 internas de 2.5 pulgadas, backplane mini-SAS HD de 12Gbps y soporte ATX para instalaciones compactas en centro de datos.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `1U | 10x 2.5 Hot-Swap + 2x 2.5 Int Opt | 12Gbps Mini-SAS HD | ATX 12x9.6 | 1x FH/HL PCIe | 1U Single/1+1`,
    images: [
      `/images/products/chenbro/rm14610-plus.jpg`,
      `/images/products/chenbro/rm14610-plus-front.jpg`,
      `/images/products/chenbro/rm14610-plus-up.jpg`,
      `/images/products/chenbro/rm14610-plus-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm146-series.pdf`,
    price: null
  },
  {
    id: `rm14300-slim-odd`,
    name: { de: `RM14300 (Slim ODD)`, en: `RM14300 (Slim ODD)`, es: `RM14300 (Slim ODD)` },
    description: {
      de: `1U Short-Depth Server-Chassis mit Front- und Rear-I/O, 1x 2.5 Zoll, 2x 3.5 Zoll sowie 1x Slim ODD für kompakte Edge- und Embedded-Systeme.`,
      en: `1U short-depth server chassis with front and rear I/O, 1x 2.5 inch, 2x 3.5 inch, and 1x slim ODD for compact edge and embedded systems.`,
      es: `Chasis de servidor 1U de poca profundidad con I/O frontal y trasera, 1 bahía de 2.5 pulgadas, 2 de 3.5 pulgadas y 1 Slim ODD para sistemas edge y embebidos compactos.`
    },
    category: `Rackmount Chassis`,
    application: `edge`,
    specs: `1U | 1x 2.5 + 2x 3.5 + Slim ODD | Micro-ATX | Flex ATX | 409mm Depth`,
    images: [
      `/images/products/chenbro/rm14300-slim-odd.jpg`,
      `/images/products/chenbro/rm14300-slim-odd-front.jpg`,
      `/images/products/chenbro/rm14300-slim-odd-up.jpg`,
      `/images/products/chenbro/rm14300-slim-odd-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm143-series.pdf`,
    price: null
  },
  {
    id: `rm14300`,
    name: { de: `RM14300`, en: `RM14300`, es: `RM14300` },
    description: {
      de: `1U Short-Depth Server-Chassis mit Front- und Rear-I/O, 2x 2.5 Zoll und 2x 3.5 Zoll Laufwerken sowie Micro-ATX-Kompatibilität für platzkritische Installationen.`,
      en: `1U short-depth server chassis with front and rear I/O, 2x 2.5 inch and 2x 3.5 inch drive support, and Micro-ATX compatibility for space-constrained installations.`,
      es: `Chasis de servidor 1U de poca profundidad con I/O frontal y trasera, soporte para 2 unidades de 2.5 pulgadas y 2 de 3.5 pulgadas, y compatibilidad Micro-ATX para instalaciones con espacio limitado.`
    },
    category: `Rackmount Chassis`,
    application: `edge`,
    specs: `1U | 2x 2.5 + 2x 3.5 | Micro-ATX | Flex ATX | 409mm Depth`,
    images: [
      `/images/products/chenbro/rm14300.jpg`,
      `/images/products/chenbro/rm14300-front.jpg`,
      `/images/products/chenbro/rm14300-up.jpg`,
      `/images/products/chenbro/rm14300-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm143-series.pdf`,
    price: null
  },
  {
    id: `rm14302-fio`,
    name: { de: `RM14302 FIO`, en: `RM14302 FIO`, es: `RM14302 FIO` },
    description: {
      de: `1U Short-Depth Server-Chassis mit Front-I/O, 2x 2.5 Zoll Hot-Swap, 2-Port 12G SAS/SATA Backplane, ATX/uATX-Support und PCIe x16 Riser für kompakte Edge-Systeme.`,
      en: `1U short-depth server chassis with front I/O, 2x 2.5 inch hot-swap bays, 2-port 12G SAS/SATA backplane, ATX/uATX support, and a PCIe x16 riser for compact edge systems.`,
      es: `Chasis de servidor 1U de poca profundidad con I/O frontal, 2 bahías hot-swap de 2.5 pulgadas, backplane SAS/SATA 12G de 2 puertos, soporte ATX/uATX y riser PCIe x16 para sistemas edge compactos.`
    },
    category: `Rackmount Chassis`,
    application: `edge`,
    specs: `1U | 409mm Depth | 2x 2.5 Hot-Swap | 2-Port 12G SAS/SATA | ATX/uATX | 500W Flex ATX | FIO`,
    images: [
      `/images/products/chenbro/rm14302-fio.jpg`,
      `/images/products/chenbro/rm14302-fio-front.jpg`,
      `/images/products/chenbro/rm14302-fio-up.jpg`,
      `/images/products/chenbro/rm14302-fio-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm14302-fio.pdf`,
    price: null
  },
  {
    id: `rm14302-rio`,
    name: { de: `RM14302 RIO`, en: `RM14302 RIO`, es: `RM14302 RIO` },
    description: {
      de: `1U Short-Depth Server-Chassis mit Rear-I/O, 2x 2.5 Zoll Hot-Swap, 2-Port 12G SAS/SATA Backplane, ATX/uATX-Support und PCIe x16 Riser für Industrie- und Edge-Umgebungen.`,
      en: `1U short-depth server chassis with rear I/O, 2x 2.5 inch hot-swap bays, 2-port 12G SAS/SATA backplane, ATX/uATX support, and a PCIe x16 riser for industrial and edge environments.`,
      es: `Chasis de servidor 1U de poca profundidad con I/O trasera, 2 bahías hot-swap de 2.5 pulgadas, backplane SAS/SATA 12G de 2 puertos, soporte ATX/uATX y riser PCIe x16 para entornos industriales y edge.`
    },
    category: `Rackmount Chassis`,
    application: `edge`,
    specs: `1U | 409mm Depth | 2x 2.5 Hot-Swap | 2-Port 12G SAS/SATA | ATX/uATX | 500W Flex ATX | RIO`,
    images: [
      `/images/products/chenbro/rm14302-rio.jpg`,
      `/images/products/chenbro/rm14302-rio-front.jpg`,
      `/images/products/chenbro/rm14302-rio-up.jpg`,
      `/images/products/chenbro/rm14302-rio-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm14302-rio.pdf`,
    price: null
  },
  {
    id: `rm13304-mio-sas`,
    name: { de: `RM13304 MIO (SAS/SATA)`, en: `RM13304 MIO (SAS/SATA)`, es: `RM13304 MIO (SAS/SATA)` },
    description: {
      de: `1U Multiple-I/O Storage-Server-Chassis mit 4x 3.5 Zoll Hot-Swap, 2x internen 2.5 Zoll, 1x Slim ODD, Dual-Socket-EEB-Support und 1+1 redundanten 750W für Cloud-, HPC- und Backup-Workloads.`,
      en: `1U multiple-I/O storage server chassis with 4x 3.5 inch hot-swap bays, 2x internal 2.5 inch bays, 1x slim ODD, dual-socket EEB support, and redundant 1+1 750W power for cloud, HPC, and backup workloads.`,
      es: `Chasis de servidor 1U para almacenamiento de múltiples I/O con 4 bahías hot-swap de 3.5 pulgadas, 2 internas de 2.5 pulgadas, 1 Slim ODD, soporte Dual-Socket EEB y fuente redundante 1+1 de 750W para cloud, HPC y backup.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `1U | 4x 3.5 Hot-Swap SAS/SATA + 2x 2.5 Int + Slim ODD | EEB 12x13 | 2x PCIe 4.0 x16 LP/HL | 1+1 750W`,
    images: [
      `/images/products/chenbro/rm13304-mio-sas.jpg`,
      `/images/products/chenbro/rm13304-mio-sas-front.jpg`,
      `/images/products/chenbro/rm13304-mio-sas-up.jpg`,
      `/images/products/chenbro/rm13304-mio-sas-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm13304-mio-sas.pdf`,
    price: null
  },
  {
    id: `rm13304-mio-tri-mode`,
    name: { de: `RM13304 MIO (Tri-mode)`, en: `RM13304 MIO (Tri-mode)`, es: `RM13304 MIO (Tri-mode)` },
    description: {
      de: `1U Multiple-I/O Storage-Server-Chassis mit 4x 3.5 Zoll Combo-Bay Hot-Swap und Tri-mode-Unterstützung für SAS, SATA und NVMe Gen4 in datenintensiven Enterprise- und HPC-Umgebungen.`,
      en: `1U multiple-I/O storage server chassis with 4x 3.5 inch combo-bay hot-swap and tri-mode support for SAS, SATA, and NVMe Gen4 in data-intensive enterprise and HPC environments.`,
      es: `Chasis de servidor 1U para almacenamiento de múltiples I/O con 4 bahías combo hot-swap de 3.5 pulgadas y soporte tri-mode para SAS, SATA y NVMe Gen4 en entornos empresariales y HPC intensivos en datos.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `1U | 4x 3.5 Combo-Bay SAS/SATA/NVMe Gen4 + 2x 2.5 Int + Slim ODD | EEB 12x13 | 2x PCIe 4.0 x16 LP/HL | 1+1 750W`,
    images: [
      `/images/products/chenbro/rm13304-mio-trimode.jpg`,
      `/images/products/chenbro/rm13304-mio-tri-mode-front.jpg`,
      `/images/products/chenbro/rm13304-mio-trimode-up.jpg`,
      `/images/products/chenbro/rm13304-mio-trimode-rear.jpg`
    ],
    videoUrl: `https://www.youtube.com/watch?v=H3zH-bBnK1s`,
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm13304-mio-tri-mode.pdf`,
    price: null
  },

  // ========== 2U SERIES ==========
  {
    id: `rm23800`,
    name: { de: `RM23800`, en: `RM23800`, es: `RM23800` },
    description: {
      de: `2U Dual-Socket Server-Chassis mit 4x 3.5 Zoll internen Laufwerken, SSI-EEB-Support und flexiblen 1+1-CRPS- oder 2U-Single-PSU-Optionen.`,
      en: `2U dual-socket server chassis with 4x 3.5 inch internal drive support, SSI EEB support, and flexible 1+1 CRPS or 2U single PSU options.`,
      es: `Chasis de servidor 2U de doble socket con soporte para 4 unidades internas de 3.5 pulgadas, soporte SSI EEB y opciones flexibles de fuente 1+1 CRPS o 2U simple.`
    },
    category: `Rackmount Chassis`,
    application: `cloud`,
    specs: `2U | 4x 3.5 Internal + 2x Open Bay | N/A | SSI EEB | 1+1 CRPS / 2U Single`,
    images: [
      `/images/products/chenbro/rm23800.jpg`,
      `/images/products/chenbro/rm23800-front.jpg`,
      `/images/products/chenbro/rm23800-up.jpg`,
      `/images/products/chenbro/rm23800-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm238-series.pdf`,
    price: null
  },
  {
    id: `rm23804`,
    name: { de: `RM23804`, en: `RM23804`, es: `RM23804` },
    description: {
      de: `2U vielseitiges Server-Chassis mit 4x 3.5 Zoll Hot-Swap und 12Gbps SAS/SATA Backplane für flexible Enterprise- und Storage-Konfigurationen.`,
      en: `2U versatile server chassis with 4x 3.5 inch hot-swap bays and 12Gbps SAS/SATA backplane for flexible enterprise and storage configurations.`,
      es: `Chasis de servidor 2U versátil con 4 bahías hot-swap de 3.5 pulgadas y backplane SAS/SATA de 12Gbps para configuraciones flexibles empresariales y de storage.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `2U | 4x 3.5 Hot-Swap + 2x Open Bay | 12Gbps SAS/SATA | SSI EEB | 1+1 CRPS / 2U Single`,
    images: [
      `/images/products/chenbro/rm23804.jpg`,
      `/images/products/chenbro/rm23804-front.jpg`,
      `/images/products/chenbro/rm23804-up.jpg`,
      `/images/products/chenbro/rm23804-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm238-series.pdf`,
    price: null
  },
  {
    id: `rm23808`,
    name: { de: `RM23808`, en: `RM23808`, es: `RM23808` },
    description: {
      de: `2U General-Purpose Storage-Chassis mit 8x 3.5 Zoll Hot-Swap, 2x internen 2.5 Zoll, 1x Slim ODD und 12Gbps Mini-SAS-HD Backplane.`,
      en: `2U general-purpose storage chassis with 8x 3.5 inch hot-swap bays, 2x internal 2.5 inch bays, 1x slim ODD, and a 12Gbps mini-SAS HD backplane.`,
      es: `Chasis 2U de almacenamiento de propósito general con 8 bahías hot-swap de 3.5 pulgadas, 2 internas de 2.5 pulgadas, 1 Slim ODD y backplane mini-SAS HD de 12Gbps.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `2U | 8x 3.5 Hot-Swap + 2x 2.5 Int + Slim ODD | 12Gbps Mini-SAS HD | SSI EEB | 1+1 CRPS / 2U Single`,
    images: [
      `/images/products/chenbro/rm23808.jpg`,
      `/images/products/chenbro/rm23808-front.jpg`,
      `/images/products/chenbro/rm23808-up.jpg`,
      `/images/products/chenbro/rm23808-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm238-series.pdf`,
    price: null
  },
  {
    id: `rm23812`,
    name: { de: `RM23812`, en: `RM23812`, es: `RM23812` },
    description: {
      de: `2U Dual-Socket Storage-Server-Chassis mit 12x 3.5 Zoll Hot-Swap und wahlweise aktiver oder passiver 12Gbps SAS/SATA Backplane für Enterprise-Storage.`,
      en: `2U dual-socket storage server chassis with 12x 3.5 inch hot-swap bays and either active or passive 12Gbps SAS/SATA backplane for enterprise storage.`,
      es: `Chasis de servidor 2U de doble socket para almacenamiento con 12 bahías hot-swap de 3.5 pulgadas y backplane SAS/SATA 12Gbps activa o pasiva para storage empresarial.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `2U | 12x 3.5 Hot-Swap | 12Gbps SAS/SATA Active/Passive | SSI EEB | 7x LP / 3x FH | 1+1 CRPS / 2U Single`,
    images: [
      `/images/products/chenbro/rm23812.jpg`,
      `/images/products/chenbro/rm23812-front.jpg`,
      `/images/products/chenbro/rm23812-up.jpg`,
      `/images/products/chenbro/rm23812-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm238-series.pdf`,
    price: null
  },
  {
    id: `rm23824`,
    name: { de: `RM23824`, en: `RM23824`, es: `RM23824` },
    description: {
      de: `2U High-Density Storage-Chassis mit 24x 2.5 Zoll Hot-Swap und flexiblen SAS/SATA- sowie NVMe-Backplane-Optionen für hohe I/O-Leistung und niedrige Latenz.`,
      en: `2U high-density storage chassis with 24x 2.5 inch hot-swap bays and flexible SAS/SATA plus NVMe backplane options for high I/O performance and low latency.`,
      es: `Chasis 2U de almacenamiento de alta densidad con 24 bahías hot-swap de 2.5 pulgadas y opciones flexibles de backplane SAS/SATA y NVMe para alto rendimiento I/O y baja latencia.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `2U | 24x 2.5 Hot-Swap + Optional 2x 2.5 Rear | SAS/SATA / NVMe | SSI EEB | 7x LP / 3x FH | 1+1 CRPS / 2U Single`,
    images: [
      `/images/products/chenbro/rm23824.jpg`,
      `/images/products/chenbro/rm23824-front.jpg`,
      `/images/products/chenbro/rm23824-up.jpg`,
      `/images/products/chenbro/rm23824-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm238-series.pdf`,
    price: null
  },
  {
    id: `rm24100`,
    name: { de: `RM24100`, en: `RM24100`, es: `RM24100` },
    description: {
      de: `2U Rackmount-Server-Chassis mit kurzer Bautiefe und ATX-Unterstützung für kompakte professionelle Installationen mit PS/2-Netzteilkonzept.`,
      en: `2U rackmount server chassis with short-depth design and ATX support for compact professional installations using a PS/2 power concept.`,
      es: `Chasis de servidor rackmount 2U de poca profundidad con soporte ATX para instalaciones profesionales compactas y arquitectura de fuente PS/2.`
    },
    category: `Rackmount Chassis`,
    application: `cloud`,
    specs: `2U | Short Depth | ATX | PS/2`,
    images: [
      `/images/products/chenbro/rm24100.jpg`,
      `/images/products/chenbro/rm24100-front.jpg`,
      `/images/products/chenbro/rm24100-up.jpg`,
      `/images/products/chenbro/rm24100-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm24100.pdf`,
    price: null
  },
  {
    id: `rm24100-l2`,
    name: { de: `RM24100-L2`, en: `RM24100-L2`, es: `RM24100-L2` },
    description: {
      de: `2U Low-Profile Rackmount-Server-Chassis mit kurzer Bautiefe und Frontklappe für platzkritische Integrationen ohne vorinstalliertes Netzteil.`,
      en: `2U low-profile rackmount server chassis with short-depth design and front door for space-constrained integrations without a preinstalled PSU.`,
      es: `Chasis de servidor rackmount 2U de perfil bajo, poca profundidad y puerta frontal para integraciones con espacio limitado, sin PSU preinstalada.`
    },
    category: `Rackmount Chassis`,
    application: `edge`,
    specs: `2U | Low Profile | ATX | Short Depth | w/o PSU`,
    images: [
      `/images/products/chenbro/rm24100-l2.jpg`,
      `/images/products/chenbro/rm24100-l2-front.jpg`,
      `/images/products/chenbro/rm24100-l2-up.jpg`,
      `/images/products/chenbro/rm24100-l2-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm24100-l2.pdf`,
    price: null
  },
  {
    id: `rm24500-gpu`,
    name: { de: `RM24500 GPU`, en: `RM24500 GPU`, es: `RM24500 GPU` },
    description: {
      de: `2U flexibles GPU-Server-Chassis mit ATX/mATX-Support, 1x 3.5 Zoll, 1x 2.5 Zoll, 3x Full-Height-Slots und Plattformdesign für beschleunigtes Computing.`,
      en: `2U flexible GPU server chassis with ATX/mATX support, 1x 3.5 inch, 1x 2.5 inch, 3 full-height slots, and a platform design for accelerated computing.`,
      es: `Chasis de servidor 2U flexible para GPU con soporte ATX/mATX, 1 unidad de 3.5 pulgadas, 1 de 2.5 pulgadas, 3 slots full-height y diseño orientado a cómputo acelerado.`
    },
    category: `Rackmount Chassis`,
    application: `ai`,
    specs: `2U | 1x 3.5 Int + 1x 2.5 Int + 2x Open Bay | ATX/mATX | 3x FH | 1+1 CRPS / 2U Single`,
    images: [
      `/images/products/chenbro/rm24500-gpu.jpg`,
      `/images/products/chenbro/rm24500-gpu-front.jpg`,
      `/images/products/chenbro/rm24500-gpu-up.jpg`,
      `/images/products/chenbro/rm24500-gpu-rear.jpg`
    ],
    videoUrl: `https://www.youtube.com/watch?v=H3zH-bBnK1s`,
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm245-series.pdf`,
    price: null
  },
  {
    id: `rm24504`,
    name: { de: `RM24504`, en: `RM24504`, es: `RM24504` },
    description: {
      de: `2U modulares Storage-Server-Chassis mit 4x 3.5 Zoll Hot-Swap, 12Gbps Mini-SAS-HD Backplane und optionalem rear 2x 2.5 Zoll OS-Kit.`,
      en: `2U modular storage server chassis with 4x 3.5 inch hot-swap bays, 12Gbps mini-SAS HD backplane, and an optional rear 2x 2.5 inch OS kit.`,
      es: `Chasis de servidor 2U modular para almacenamiento con 4 bahías hot-swap de 3.5 pulgadas, backplane mini-SAS HD de 12Gbps y kit trasero opcional de 2 unidades de 2.5 pulgadas para SO.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `2U | 4x 3.5 Hot-Swap + 2x Open Bay | 12Gbps Mini-SAS HD | ATX/mATX | 7x LP / 3x FH | 1+1 CRPS / 2U Single`,
    images: [
      `/images/products/chenbro/rm24504.jpg`,
      `/images/products/chenbro/rm24504-front.jpg`,
      `/images/products/chenbro/rm24504-up.jpg`,
      `/images/products/chenbro/rm24504-rear.jpg`
    ],
    videoUrl: `https://www.youtube.com/watch?v=H3zH-bBnK1s`,
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm245-series.pdf`,
    price: null
  },
  {
    id: `rm24508`,
    name: { de: `RM24508`, en: `RM24508`, es: `RM24508` },
    description: {
      de: `2U flexibles Storage-Server-Chassis mit 8x 3.5 Zoll Hot-Swap, 1x Slim ODD, 2x internen 2.5 Zoll und optional 2x rear 2.5 Zoll Hot-Swap für OS oder Cache.`,
      en: `2U flexible storage server chassis with 8x 3.5 inch hot-swap bays, 1x slim ODD, 2x internal 2.5 inch bays, and optional 2x rear 2.5 inch hot-swap bays for OS or cache.`,
      es: `Chasis de servidor 2U flexible para almacenamiento con 8 bahías hot-swap de 3.5 pulgadas, 1 Slim ODD, 2 internas de 2.5 pulgadas y opción de 2 bahías hot-swap traseras de 2.5 pulgadas para SO o caché.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `2U | 8x 3.5 Hot-Swap + 1x Slim ODD + 2x 2.5 Int + 2x 2.5 Rear Opt | 8-Port 12Gbps Mini-SAS HD | ATX 12x9.6 | 7x LP / 3x FH | 2U Single/1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm24508.jpg`,
      `/images/products/chenbro/rm24508-front.jpg`,
      `/images/products/chenbro/rm24508-up.jpg`,
      `/images/products/chenbro/rm24508-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm245-series.pdf`,
    price: null
  },
  {
    id: `rm24512`,
    name: { de: `RM24512`, en: `RM24512`, es: `RM24512` },
    description: {
      de: `2U flexibles Storage-Server-Chassis mit 12x 3.5 Zoll Hot-Swap, optionalem rear 2x 2.5 Zoll OS-Kit, 12-Port 12Gbps Mini-SAS-HD Backplane und modularer Slot-Konfiguration.`,
      en: `2U flexible storage server chassis with 12x 3.5 inch hot-swap bays, optional rear 2x 2.5 inch OS kit, 12-port 12Gbps mini-SAS HD backplane, and modular slot configuration.`,
      es: `Chasis de servidor 2U flexible para almacenamiento con 12 bahías hot-swap de 3.5 pulgadas, kit trasero opcional de 2 unidades de 2.5 pulgadas para SO, backplane mini-SAS HD de 12 puertos a 12Gbps y configuración modular de slots.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `2U | 12x 3.5 Hot-Swap + 2x 2.5 Rear Opt | 12-Port 12Gbps Mini-SAS HD | ATX 12x9.6 | 7x LP / 3x FH | 2U Single/1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm24512.jpg`,
      `/images/products/chenbro/rm24512-front.jpg`,
      `/images/products/chenbro/rm24512-up.jpg`,
      `/images/products/chenbro/rm24512-rear.jpg`
    ],
    videoUrl: `https://www.youtube.com/watch?v=H3zH-bBnK1s`,
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm245-series.pdf`,
    price: null
  },
  {
    id: `rm25204-rio`,
    name: { de: `RM25204 RIO`, en: `RM25204 RIO`, es: `RM25204 RIO` },
    description: {
      de: `2U ultra-kurzes Edge-Computing-Server-Chassis mit Rear-I/O, 450 mm Tiefe, 4x frontalen 2.5 Zoll Hot-Swap und optionalen 2x rear 2.5 Zoll SAS/SATA oder NVMe.`,
      en: `2U ultra-short edge computing server chassis with rear I/O, 450 mm depth, 4x front 2.5 inch hot-swap bays, and optional 2x rear 2.5 inch SAS/SATA or NVMe.`,
      es: `Chasis de servidor 2U ultra-corto para edge computing con I/O trasera, 450 mm de profundidad, 4 bahías frontales hot-swap de 2.5 pulgadas y opción de 2 traseras de 2.5 pulgadas SAS/SATA o NVMe.`
    },
    category: `Rackmount Chassis`,
    application: `edge`,
    specs: `2U | 450mm Depth | 4x 2.5 Hot-Swap Front + 2x 2.5 Rear Opt | SAS/SATA / PCIe Gen3 NVMe | E-ATX/CEB/ATX | 3x FH / 7x LP | 2U 800W 1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm25204-rio.jpg`,
      `/images/products/chenbro/rm25204-rio-front.jpg`,
      `/images/products/chenbro/rm25204-rio-up.jpg`,
      `/images/products/chenbro/rm25204-rio-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm252-fio.pdf`,
    price: null
  },
  {
    id: `rm25206-fio`,
    name: { de: `RM25206 FIO`, en: `RM25206 FIO`, es: `RM25206 FIO` },
    description: {
      de: `2U ultra-kurzes Edge-Computing-Server-Chassis mit Front-I/O, 450 mm Tiefe und 6x 2.5 Zoll Hot-Swap über 12Gbps SAS/SATA Backplane.`,
      en: `2U ultra-short edge computing server chassis with front I/O, 450 mm depth, and 6x 2.5 inch hot-swap bays via a 12Gbps SAS/SATA backplane.`,
      es: `Chasis de servidor 2U ultra-corto para edge computing con I/O frontal, 450 mm de profundidad y 6 bahías hot-swap de 2.5 pulgadas mediante backplane SAS/SATA de 12Gbps.`
    },
    category: `Rackmount Chassis`,
    application: `edge`,
    specs: `2U | 450mm Depth | 6x 2.5 Hot-Swap | 6-Port 12Gbps SAS/SATA | E-ATX/CEB/ATX | 3x FH / 7x LP | 2U 800W 1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm25206-fio.jpg`,
      `/images/products/chenbro/rm25206-fio-front.jpg`,
      `/images/products/chenbro/rm25206-fio-up.jpg`,
      `/images/products/chenbro/rm25206-fio-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm252-fio.pdf`,
    price: null
  },
  {
    id: `rm25204-mio-rio`,
    name: { de: `RM25204 MIO RIO`, en: `RM25204 MIO RIO`, es: `RM25204 MIO RIO` },
    description: {
      de: `2U ultra-kurzes Edge-AI-Server-Chassis mit Rear-I/O, 4x frontalen und 2x rear 2.5 Zoll Hot-Swap sowie gemischter NVMe- und SAS/SATA-Backplane für GPU/GPGPU-Workloads.`,
      en: `2U ultra-short edge AI server chassis with rear I/O, 4x front and 2x rear 2.5 inch hot-swap bays, and a mixed NVMe plus SAS/SATA backplane for GPU/GPGPU workloads.`,
      es: `Chasis de servidor 2U ultra-corto para edge AI con I/O trasera, 4 bahías frontales y 2 traseras hot-swap de 2.5 pulgadas, y backplane mixta NVMe y SAS/SATA para cargas con GPU/GPGPU.`
    },
    category: `Rackmount Chassis`,
    application: `ai`,
    specs: `2U | 450mm Depth | 6x 2.5 Hot-Swap (4 Front + 2 Rear) | 2-Port PCIe Gen4 NVMe + 4-Port SAS/SATA | E-ATX/CEB/ATX | Up to 2 GPU/GPGPU | 1+1 1200W CRPS`,
    images: [
      `/images/products/chenbro/rm25204-mio-rio.jpg`,
      `/images/products/chenbro/rm25204-mio-rio-front.jpg`,
      `/images/products/chenbro/rm25204-mio-rio-up.jpg`,
      `/images/products/chenbro/rm25204-mio-rio-rear.jpg`
    ],
    videoUrl: `https://www.youtube.com/watch?v=CnoPVZlXMjk`,
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm252-mio.pdf`,
    price: null
  },
  {
    id: `rm25206-mio-fio-tri-mode`,
    name: { de: `RM25206 MIO FIO`, en: `RM25206 MIO FIO`, es: `RM25206 MIO FIO` },
    description: {
      de: `2U ultra-kurzes Edge-AI-Server-Chassis mit Front-I/O, 6x 2.5 Zoll Hot-Swap und flexiblen SAS/SATA- bzw. NVMe-Gen4-Backplane-Optionen für GPU- und Smart-City-Anwendungen.`,
      en: `2U ultra-short edge AI server chassis with front I/O, 6x 2.5 inch hot-swap bays, and flexible SAS/SATA or NVMe Gen4 backplane options for GPU and smart-city applications.`,
      es: `Chasis de servidor 2U ultra-corto para edge AI con I/O frontal, 6 bahías hot-swap de 2.5 pulgadas y opciones flexibles de backplane SAS/SATA o NVMe Gen4 para aplicaciones con GPU y smart city.`
    },
    category: `Rackmount Chassis`,
    application: `ai`,
    specs: `2U | 450mm Depth | 6x 2.5 Hot-Swap | 6-Port SAS/SATA or Mixed NVMe Gen4 + SAS/SATA | E-ATX/CEB/ATX | Up to 2 GPGPU | 1+1 1200W CRPS`,
    images: [
      `/images/products/chenbro/rm25206-mio-fio-trimode.jpg`,
      `/images/products/chenbro/rm25206-mio-fio-trimode-front.jpg`,
      `/images/products/chenbro/rm25206-mio-fio-trimode-up.jpg`,
      `/images/products/chenbro/rm25206-mio-fio-trimode-rear.jpg`
    ],
    videoUrl: `https://www.youtube.com/watch?v=CnoPVZlXMjk`,
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm252-mio.pdf`,
    price: null
  },

  // ========== 3U SERIES ==========
  {
    id: `rm31616`,
    name: { de: `RM31616`, en: `RM31616`, es: `RM31616` },
    description: {
      de: `3U High-Density Storage-Server-Chassis mit 16x 3.5 Zoll Hot-Swap, 12Gbps Expander-Backplane, Slim ODD, Slim FDD und 1+1 CRPS 1200W für datenintensive Anwendungen.`,
      en: `3U high-density storage server chassis with 16x 3.5 inch hot-swap bays, 12Gbps expander backplane, slim ODD, slim FDD, and 1+1 1200W CRPS for data-intensive applications.`,
      es: `Chasis de servidor 3U de alta densidad para almacenamiento con 16 bahías hot-swap de 3.5 pulgadas, backplane con expander de 12Gbps, Slim ODD, Slim FDD y 1+1 CRPS de 1200W para aplicaciones intensivas en datos.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `3U | 16x 3.5 Hot-Swap + Slim ODD + Slim FDD | 12Gbps Mini-SAS HD w/ Expander | SSI EEB | 7x FH/FL | 1+1 1200W CRPS`,
    images: [
      `/images/products/chenbro/rm31616.jpg`,
      `/images/products/chenbro/rm31616-front.jpg`,
      `/images/products/chenbro/rm31616-up.jpg`,
      `/images/products/chenbro/rm31616-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm31616.pdf`,
    price: null
  },
  {
    id: `rm35206-fio`,
    name: { de: `RM35206 FIO`, en: `RM35206 FIO`, es: `RM35206 FIO` },
    description: {
      de: `3U GPGPU Short-Depth Server-Chassis mit Front-I/O, 450 mm Tiefe, 6x frontalen und 2x rear 2.5 Zoll Hot-Swap sowie bis zu 8 Full-Height-Slots für Edge-AI.`,
      en: `3U GPGPU short-depth server chassis with front I/O, 450 mm depth, 6 front and 2 rear 2.5 inch hot-swap bays, and up to 8 full-height slots for edge AI.`,
      es: `Chasis de servidor 3U GPGPU de poca profundidad con I/O frontal, 450 mm de profundidad, 6 bahías frontales y 2 traseras hot-swap de 2.5 pulgadas y hasta 8 slots full-height para edge AI.`
    },
    category: `Rackmount Chassis`,
    application: `ai`,
    specs: `3U | 450mm Depth | 6x 2.5 Hot-Swap Front + 2x 2.5 Rear | SAS/SATA / NVMe | SSI EEB/CEB/ATX | 8x FH | 2U 1600W 1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm35206-fio.jpg`,
      `/images/products/chenbro/rm35206-fio-front.jpg`,
      `/images/products/chenbro/rm35206-fio-up.jpg`,
      `/images/products/chenbro/rm35206-fio-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm352.pdf`,
    price: null
  },
  {
    id: `rm35206-rio`,
    name: { de: `RM35206 RIO`, en: `RM35206 RIO`, es: `RM35206 RIO` },
    description: {
      de: `3U GPGPU Short-Depth Server-Chassis mit Rear-I/O, 450 mm Tiefe, 6x frontalen und 2x rear 2.5 Zoll Hot-Swap sowie bis zu 4 Double-Width-GPUs.`,
      en: `3U GPGPU short-depth server chassis with rear I/O, 450 mm depth, 6 front and 2 rear 2.5 inch hot-swap bays, and support for up to 4 double-width GPUs.`,
      es: `Chasis de servidor 3U GPGPU de poca profundidad con I/O trasera, 450 mm de profundidad, 6 bahías frontales y 2 traseras hot-swap de 2.5 pulgadas y soporte para hasta 4 GPUs de doble ancho.`
    },
    category: `Rackmount Chassis`,
    application: `ai`,
    specs: `3U | 450mm Depth | 6x 2.5 Hot-Swap Front + 2x 2.5 Rear | SAS/SATA / NVMe | SSI EEB/CEB/ATX | 8x FH | 2U 1600W 1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm35206-rio.jpg`,
      `/images/products/chenbro/rm35206-rio-front.jpg`,
      `/images/products/chenbro/rm35206-rio-up.jpg`,
      `/images/products/chenbro/rm35206-rio-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm352.pdf`,
    price: null
  },

  // ========== 4U SERIES ==========
  {
    id: `rm41300`,
    name: { de: `RM41300`, en: `RM41300`, es: `RM41300` },
    description: {
      de: `4U High-Performance Industrial Server Chassis mit E-ATX-Support, 8 Full-Height-Slots, 3x 5.25 Zoll, 1x 3.5 Zoll, 1x Slim ODD und optionaler 1+1 CRPS-Lösung.`,
      en: `4U high-performance industrial server chassis with E-ATX support, 8 full-height slots, 3x 5.25 inch bays, 1x 3.5 inch bay, 1x slim ODD, and optional 1+1 CRPS support.`,
      es: `Chasis de servidor industrial 4U de alto rendimiento con soporte E-ATX, 8 slots full-height, 3 bahías de 5.25 pulgadas, 1 de 3.5 pulgadas, 1 Slim ODD y opción de fuente 1+1 CRPS.`
    },
    category: `Rackmount Chassis`,
    application: `industrial`,
    specs: `4U | 3x 5.25 + 1x 3.5 + 1x Slim ODD + 4x 3.5 Int | E-ATX | 8x FH | PS/2 or 1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm41300.jpg`,
      `/images/products/chenbro/rm41300-front.jpg`,
      `/images/products/chenbro/rm41300-up.jpg`,
      `/images/products/chenbro/rm41300-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm41300.pdf`,
    price: null
  },
  {
    id: `rm42300`,
    name: { de: `RM42300`, en: `RM42300`, es: `RM42300` },
    description: {
      de: `4U kompaktes Industrial Server Chassis mit ATX-Unterstützung, 7 Full-Height-Slots, 3x 5.25 Zoll, 1x 3.5 Zoll, 1x Slim ODD und optionalem 1+1 CRPS-Modul.`,
      en: `4U compact industrial server chassis with ATX support, 7 full-height slots, 3x 5.25 inch bays, 1x 3.5 inch bay, 1x slim ODD, and an optional 1+1 CRPS module.`,
      es: `Chasis de servidor industrial 4U compacto con soporte ATX, 7 slots full-height, 3 bahías de 5.25 pulgadas, 1 de 3.5 pulgadas, 1 Slim ODD y módulo 1+1 CRPS opcional.`
    },
    category: `Rackmount Chassis`,
    application: `industrial`,
    specs: `4U | 3x 5.25 + 1x 3.5 + 1x Slim ODD + 4x 3.5 Int | ATX | 7x FH | PS/2 or 1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm42300.jpg`,
      `/images/products/chenbro/rm42300-front.jpg`,
      `/images/products/chenbro/rm42300-up.jpg`,
      `/images/products/chenbro/rm42300-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm423.pdf`,
    price: null
  },
  {
    id: `rm41736-plus`,
    name: { de: `RM41736 Plus`, en: `RM41736 Plus`, es: `RM41736 Plus` },
    description: {
      de: `4U High-Capacity Storage-Server-Chassis mit 36x 3.5 Zoll Hot-Swap, optional 2x rear 2.5 Zoll, aktivem 12Gbps Backplane-Design und 1+1 CRPS für Rechenzentren.`,
      en: `4U high-capacity storage server chassis with 36x 3.5 inch hot-swap bays, optional 2x rear 2.5 inch bays, active 12Gbps backplane design, and 1+1 CRPS for data centers.`,
      es: `Chasis de servidor 4U de alta capacidad para almacenamiento con 36 bahías hot-swap de 3.5 pulgadas, opción de 2 traseras de 2.5 pulgadas, diseño de backplane activa de 12Gbps y 1+1 CRPS para centros de datos.`
    },
    category: `Rackmount Chassis`,
    application: `storage`,
    specs: `4U | 36x 3.5 Hot-Swap + 2x 2.5 Rear Opt | 24-Port + 12-Port 12Gbps Active Backplane | SSI EEB | 7x LP | 1+1 CRPS`,
    images: [
      `/images/products/chenbro/rm41736-plus.jpg`,
      `/images/products/chenbro/rm41736-plus-front.jpg`,
      `/images/products/chenbro/rm41736-plus-up.jpg`,
      `/images/products/chenbro/rm41736-plus-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
    datasheetUrl: `/datasheets/chenbro/rm41736.pdf`,
    price: null
  },
  {
  id: `rm41824`,
  name: { de: `RM41824 CRPS`, en: `RM41824 CRPS`, es: `RM41824 CRPS` },
  description: {
    de: `4U High-Density-Storage-Server-Chassis mit 24x 3.5 Zoll Hot-Swap-Laufwerksschächten, 12Gb/s Mini-SAS HD Expander Backplane und 1+1 CRPS 1200W 80 Plus Platinum für Enterprise- und Datacenter-Anwendungen.`,
    en: `4U high-density storage server chassis with 24x 3.5 inch hot-swap drive bays, 12Gb/s Mini-SAS HD expander backplane, and 1+1 1200W 80 Plus Platinum CRPS for enterprise and data center applications.`,
    es: `Chasis de servidor 4U de alta densidad para almacenamiento con 24 bahías hot-swap de 3.5 pulgadas, backplane expander Mini-SAS HD de 12Gb/s y fuente 1+1 CRPS de 1200W 80 Plus Platinum para aplicaciones enterprise y de centro de datos.`
  },
  category: `Rackmount Chassis`,
  application: `storage`,
  specs: `4U | 24x 3.5 Hot-Swap + 2x 2.5 Rear Opt | 12Gb/s Mini-SAS HD Expander | E-ATX 12x13 | 7x FH/FL | 1+1 CRPS 1200W`,
  images: [
    `/images/products/chenbro/rm41824-crps.jpg`,
    `/images/products/chenbro/rm41824-crps-front.jpg`,
    `/images/products/chenbro/rm41824-crps-up.jpg`,
    `/images/products/chenbro/rm41824-crps-rear.jpg`
  ],
  productUrl: `https://www.chenbro.com/de-DE/product/RackmountChassis`,
  datasheetUrl: `/datasheets/chenbro/rm41824.pdf`,
  price: null
  },
  // ========== TOWER SERVER SERIES ==========
  {
    id: `sr105-plus`,
    name: { de: `SR105 Plus`, en: `SR105 Plus`, es: `SR105 Plus` },
    description: {
      de: `Vielseitiges 4U Tower-Server-Chassis mit bis zu 8x 3.5 Zoll Hot-Swap, internen 3.5-Zoll-Käfigen, Rackmount-Option und Unterstützung für PS/2 oder redundante PSU-Varianten.`,
      en: `Versatile 4U tower server chassis with up to 8x 3.5 inch hot-swap bays, internal 3.5 inch cages, rackmount capability, and support for PS/2 or redundant PSU options.`,
      es: `Versátil chasis de servidor torre 4U con hasta 8 bahías hot-swap de 3.5 pulgadas, jaulas internas de 3.5 pulgadas, opción de rack y soporte para PSU PS/2 o redundantes.`
    },
    category: `Tower Server Chassis`,
    application: `storage`,
    specs: `Tower 4U | Up to 8x 3.5 Hot-Swap + Internal 3.5 | Rackmount Ready | PS/2 / Redundant PSU`,
    images: [
      `/images/products/chenbro/sr105plus.jpg`,
      `/images/products/chenbro/sr105plus-front.jpg`,
      `/images/products/chenbro/sr105plus-up.jpg`,
      `/images/products/chenbro/sr105plus-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/TowerServerChassis`,
    datasheetUrl: `/datasheets/chenbro/sr105.pdf`,
    price: null
  },
  {
    id: `sr107-plus`,
    name: { de: `SR107 Plus`, en: `SR107 Plus`, es: `SR107 Plus` },
    description: {
      de: `High-Data-Security E-ATX Tower-Server-Chassis mit 8x 3.5 Zoll Hot-Swap, 8x internen 3.5 Zoll, bis zu 3 GPU-Karten und PS/2-, n+1- oder 1+1-CRPS-Unterstützung.`,
      en: `High-data-security E-ATX tower server chassis with 8x 3.5 inch hot-swap bays, 8x internal 3.5 inch bays, support for up to 3 GPU cards, and PS/2, n+1, or 1+1 CRPS power options.`,
      es: `Chasis de servidor torre E-ATX de alta seguridad con 8 bahías hot-swap de 3.5 pulgadas, 8 internas de 3.5 pulgadas, soporte para hasta 3 GPU y opciones de fuente PS/2, n+1 o 1+1 CRPS.`
    },
    category: `Tower Server Chassis`,
    application: `storage`,
    specs: `Tower | E-ATX 12x13 | 8x 3.5 Hot-Swap + 8x 3.5 Int + 3x 5.25 | 12Gbps Mini-SAS HD / SAS/SATA | 7x FH | PS/2 / n+1 / 1+1 CRPS`,
    images: [
      `/images/products/chenbro/sr107plus.jpg`,
      `/images/products/chenbro/sr107plus-front.jpg`,
      `/images/products/chenbro/sr107plus-up.jpg`,
      `/images/products/chenbro/sr107plus-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/TowerServerChassis`,
    datasheetUrl: `/datasheets/chenbro/sr107.pdf`,
    price: null
  },
  {
    id: `sr113`,
    name: { de: `SR113`, en: `SR113`, es: `SR113` },
    description: {
      de: `4U Rackable Tower Server Chassis für AI, ML und HPC mit bis zu 5 Double-Width-GPGPUs, 2x 4-Bay-3.5-Zoll-Hot-Swap-Modulen und CRPS/ATX-PSU-Optionen.`,
      en: `4U rackable tower server chassis for AI, ML, and HPC with support for up to 5 double-width GPGPUs, 2x 4-bay 3.5 inch hot-swap modules, and CRPS/ATX PSU options.`,
      es: `Chasis de servidor torre 4U rackeable para AI, ML y HPC con soporte para hasta 5 GPGPUs de doble ancho, 2 módulos hot-swap de 4 bahías de 3.5 pulgadas y opciones de fuente CRPS/ATX.`
    },
    category: `Tower Server Chassis`,
    application: `ai`,
    specs: `Tower 4U | Up to 5 Double-Width GPGPU | 2x 4-Bay 3.5 SAS/SATA Hot-Swap | Proprietary / SSI EEB | CRPS 1+1 1200/2000W or PS/2`,
    images: [
      `/images/products/chenbro/sr113.jpg`,
      `/images/products/chenbro/sr113-front.jpg`,
      `/images/products/chenbro/sr113-up.jpg`,
      `/images/products/chenbro/sr113-rear.jpg`
    ],
    videoUrl: `https://www.youtube.com/watch?v=KzRu9pQIAY`,
    productUrl: `https://www.chenbro.com/de-DE/product/TowerServerChassis`,
    datasheetUrl: `/datasheets/chenbro/sr113.pdf`,
    price: null
  },
  {
    id: `sr115`,
    name: { de: `SR115`, en: `SR115`, es: `SR115` },
    description: {
      de: `4U Tower- und Rackable-Workstation-/Server-Chassis mit EEB-, ATX- und mATX-Support, bis zu zwei Storage-Kits, 8 Full-Height-Slots und ATX- oder 1+1-CRPS-Netzteilen.`,
      en: `4U tower and rackable workstation/server chassis with EEB, ATX, and mATX support, up to two storage kits, 8 full-height slots, and ATX or 1+1 CRPS power options.`,
      es: `Chasis 4U de torre y rackeable para workstation/servidor con soporte EEB, ATX y mATX, hasta dos kits de almacenamiento, 8 slots full-height y opciones de fuente ATX o 1+1 CRPS.`
    },
    category: `Tower Server Chassis`,
    application: `workstation`,
    specs: `Tower 4U | EEB/ATX/mATX | 2x 5.25 + 1x 3.5 + Optional Storage Kits | 8x FH | ATX / 1+1 CRPS`,
    images: [
      `/images/products/chenbro/sr115.jpg`,
      `/images/products/chenbro/sr115-front.jpg`,
      `/images/products/chenbro/sr115-up.jpg`,
      `/images/products/chenbro/sr115-rear.jpg`
    ],
    videoUrl: `https://www.youtube.com/watch?v=RU9Xsezf4WU`,
    productUrl: `https://www.chenbro.com/de-DE/product/TowerServerChassis`,
    datasheetUrl: `/datasheets/chenbro/sr115.pdf`,
    price: null
  },
  {
    id: `sr209-plus`,
    name: { de: `SR209 Plus`, en: `SR209 Plus`, es: `SR209 Plus` },
    description: {
      de: `Feature-reiches Tower-Server-Chassis mit großem Innenraum, Hot-Swap-/interner Käfig-Unterstützung und Rackmount-Fähigkeit für vielseitige SMB-Serverkonfigurationen.`,
      en: `Feature-rich tower server chassis with ample internal space, support for hot-swap or internal cages, and rackmount capability for versatile SMB server configurations.`,
      es: `Chasis de servidor torre con amplio espacio interno, soporte para jaulas hot-swap o internas y capacidad de rack para configuraciones versátiles de servidor SMB.`
    },
    category: `Tower Server Chassis`,
    application: `cloud`,
    specs: `Tower 4U | Multi 3.5 Bay Configuration | Rackmount Ready | PS/2 / Redundant PSU`,
    images: [
      `/images/products/chenbro/sr209-plus.jpg`,
      `/images/products/chenbro/sr209-plus-front.jpg`,
      `/images/products/chenbro/sr209-plus-up.jpg`,
      `/images/products/chenbro/sr209-plus-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/TowerServerChassis`,
    datasheetUrl: `/datasheets/chenbro/sr209.pdf`,
    price: null
  },
  {
    id: `sr215`,
    name: { de: `SR215`, en: `SR215`, es: `SR215` },
    description: {
      de: `Kurzes Tower-Server-Chassis für Workstation-Anwendungen mit ATX/mATX-Support, 2x 5.25 Zoll, 1x 3.5 Zoll und optionalen internen oder Hot-Swap-Storage-Modulen.`,
      en: `Short-depth tower server chassis for workstation applications with ATX/mATX support, 2x 5.25 inch bays, 1x 3.5 inch bay, and optional internal or hot-swap storage modules.`,
      es: `Chasis de servidor torre de poca profundidad para aplicaciones workstation con soporte ATX/mATX, 2 bahías de 5.25 pulgadas, 1 de 3.5 pulgadas y módulos opcionales de almacenamiento interno o hot-swap.`
    },
    category: `Tower Server Chassis`,
    application: `workstation`,
    specs: `Tower | ATX/mATX | 2x 5.25 + 1x 3.5 | Optional 4x 3.5 Internal or Hot-Swap Module | 8x FH | ATX 1200W / 800W 1+1 CRPS`,
    images: [
      `/images/products/chenbro/sr215.jpg`,
      `/images/products/chenbro/sr215-front.jpg`,
      `/images/products/chenbro/sr215-up.jpg`,
      `/images/products/chenbro/sr215-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/TowerServerChassis`,
    datasheetUrl: `/datasheets/chenbro/sr215.pdf`,
    price: null
  },
  {
    id: `sr301-plus`,
    name: { de: `SR301 Plus`, en: `SR301 Plus`, es: `SR301 Plus` },
    description: {
      de: `Kompaktes Business-Tower-Server-Chassis mit Mini-ITX-Support, integriertem 4-Port-Mini-SAS-Backplane, 4x 3.5 Zoll Hot-Swap und 2x internen Laufwerken.`,
      en: `Compact business tower server chassis with Mini-ITX support, built-in 4-port mini-SAS backplane, 4x 3.5 inch hot-swap bays, and 2x internal drive bays.`,
      es: `Compacto chasis de servidor torre para negocio con soporte Mini-ITX, backplane mini-SAS integrada de 4 puertos, 4 bahías hot-swap de 3.5 pulgadas y 2 bahías internas.`
    },
    category: `Tower Server Chassis`,
    application: `storage`,
    specs: `Tower Mini | Mini-ITX | 4x 3.5 Hot-Swap + 2x Internal | 4-Port Mini-SAS | Low Profile Expansion | PS/2`,
    images: [
      `/images/products/chenbro/sr301-plus.jpg`,
      `/images/products/chenbro/sr301-plus-front.jpg`,
      `/images/products/chenbro/sr301-plus-up.jpg`,
      `/images/products/chenbro/sr301-plus-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/TowerServerChassis`,
    datasheetUrl: `/datasheets/chenbro/sr301.pdf`,
    price: null
  },

  // ========== PC CHASSIS SERIES ==========
  {
    id: `pc617`,
    name: { de: `PC617`, en: `PC617`, es: `PC617` },
    description: {
      de: `ATX Mid-Tower-PC-Gehäuse mit hoher Skalierbarkeit, 4x 5.25 Zoll, 1-2x 3.5 Zoll extern, 2x 3.5 Zoll intern und 7 Full-Height-Slots.`,
      en: `ATX mid-tower PC chassis with high scalability, 4x 5.25 inch bays, 1-2x external 3.5 inch bays, 2x internal 3.5 inch bays, and 7 full-height slots.`,
      es: `Chasis PC mid-tower ATX de alta escalabilidad con 4 bahías de 5.25 pulgadas, 1-2 externas de 3.5 pulgadas, 2 internas de 3.5 pulgadas y 7 slots full-height.`
    },
    category: `PC Chassis`,
    application: `office`,
    specs: `ATX Mid-Tower | 4x 5.25 + 1-2x 3.5 Ext + 2x 3.5 Int | PS/2 | 7x FH`,
    images: [
      `/images/products/chenbro/pc617.jpg`,
      `/images/products/chenbro/pc617-front.jpg`,
      `/images/products/chenbro/pc617-up.jpg`,
      `/images/products/chenbro/pc617-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/PCChassis`,
    datasheetUrl: `/datasheets/chenbro/pc617.pdf`,
    price: null
  },
  {
    id: `pc310`,
    name: { de: `PC310`, en: `PC310`, es: `PC310` },
    description: {
      de: `Tool-less Micro-ATX Mini-Tower-Gehäuse mit 2x 5.25 Zoll, 1-2x 3.5 Zoll extern, 2x 3.5 Zoll intern und Unterstützung für 4 Full-Height-Erweiterungsslots.`,
      en: `Tool-less Micro-ATX mini-tower chassis with 2x 5.25 inch bays, 1-2x external 3.5 inch bays, 2x internal 3.5 inch bays, and support for 4 full-height expansion slots.`,
      es: `Chasis mini-tower Micro-ATX tool-less con 2 bahías de 5.25 pulgadas, 1-2 externas de 3.5 pulgadas, 2 internas de 3.5 pulgadas y soporte para 4 slots de expansión full-height.`
    },
    category: `PC Chassis`,
    application: `office`,
    specs: `Micro-ATX Mini-Tower | 2x 5.25 + 1-2x 3.5 Ext + 2x 3.5 Int | PS/2 | 4x FH`,
    images: [
      `/images/products/chenbro/pc310.jpg`,
      `/images/products/chenbro/pc310-front.jpg`,
      `/images/products/chenbro/pc310-up.jpg`,
      `/images/products/chenbro/pc310-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/PCChassis`,
    datasheetUrl: `/datasheets/chenbro/pc310.pdf`,
    price: null
  },
  {
    id: `pc314`,
    name: { de: `PC314`, en: `PC314`, es: `PC314` },
    description: {
      de: `Stabiles Micro-ATX Mini-Tower-Gehäuse mit 2x 5.25 Zoll, 2x 3.5 Zoll extern, 3x 3.5 Zoll intern, 1x 2.5 Zoll intern und verbesserter Luftführung.`,
      en: `Sturdy Micro-ATX mini-tower chassis with 2x 5.25 inch bays, 2x external 3.5 inch bays, 3x internal 3.5 inch bays, 1x internal 2.5 inch bay, and improved airflow.`,
      es: `Robusto chasis mini-tower Micro-ATX con 2 bahías de 5.25 pulgadas, 2 externas de 3.5 pulgadas, 3 internas de 3.5 pulgadas, 1 interna de 2.5 pulgadas y flujo de aire mejorado.`
    },
    category: `PC Chassis`,
    application: `office`,
    specs: `Micro-ATX Mini-Tower | 2x 5.25 + 2x 3.5 Ext + 3x 3.5 Int + 1x 2.5 Int | PS/2 | 4x FH`,
    images: [
      `/images/products/chenbro/pc314.jpg`,
      `/images/products/chenbro/pc314-front.jpg`,
      `/images/products/chenbro/pc314-up.jpg`,
      `/images/products/chenbro/pc314-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/PCChassis`,
    datasheetUrl: `/datasheets/chenbro/pc314.pdf`,
    price: null
  },
  {
    id: `pc710`,
    name: { de: `PC710`, en: `PC710`, es: `PC710` },
    description: {
      de: `Micro-ATX Slim Desktop/Tower-Gehäuse mit TFX-Netzteil, 1x 5.25 Zoll, optional 1x 3.5 Zoll extern, 1x 3.5 Zoll intern und 4 Low-Profile-Slots.`,
      en: `Micro-ATX slim desktop/tower chassis with TFX PSU, 1x 5.25 inch bay, optional 1x external 3.5 inch bay, 1x internal 3.5 inch bay, and 4 low-profile slots.`,
      es: `Chasis slim desktop/tower Micro-ATX con fuente TFX, 1 bahía de 5.25 pulgadas, opción de 1 externa de 3.5 pulgadas, 1 interna de 3.5 pulgadas y 4 slots low-profile.`
    },
    category: `PC Chassis`,
    application: `office`,
    specs: `Micro-ATX Slim Desktop/Tower | 1x 5.25 + 0-1x 3.5 Ext + 1x 3.5 Int | TFX | 4x LP`,
    images: [
      `/images/products/chenbro/pc710.jpg`,
      `/images/products/chenbro/pc710-front.jpg`,
      `/images/products/chenbro/pc710-up.jpg`,
      `/images/products/chenbro/pc710-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/PCChassis`,
    datasheetUrl: `/datasheets/chenbro/pc710.pdf`,
    price: null
  },
  {
    id: `pc719`,
    name: { de: `PC719`, en: `PC719`, es: `PC719` },
    description: {
      de: `Micro-ATX Slim Desktop/Tower-Gehäuse mit TFX-Netzteil, Slim ODD, internem 3.5-Zoll-Laufwerk, Luftkanal und waschbarem Staubfilter für kleine Footprints.`,
      en: `Micro-ATX slim desktop/tower chassis with TFX PSU, slim ODD, internal 3.5 inch drive support, air duct, and a washable dust filter for small footprints.`,
      es: `Chasis slim desktop/tower Micro-ATX con fuente TFX, Slim ODD, soporte para unidad interna de 3.5 pulgadas, ducto de aire y filtro lavable para espacios reducidos.`
    },
    category: `PC Chassis`,
    application: `office`,
    specs: `Micro-ATX Slim Desktop/Tower | Slim ODD + Optional Slim FDD + 1x 3.5 Int | TFX | 4x LP`,
    images: [
      `/images/products/chenbro/pc719.jpg`,
      `/images/products/chenbro/pc719-front.jpg`,
      `/images/products/chenbro/pc719-up.jpg`,
      `/images/products/chenbro/pc719-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/PCChassis`,
    datasheetUrl: `/datasheets/chenbro/pc719.pdf`,
    price: null
  },
  {
    id: `pc722`,
    name: { de: `PC722`, en: `PC722`, es: `PC722` },
    description: {
      de: `Value-added Micro-ATX Slim Desktop/Tower-Gehäuse mit Slim ODD, bis zu 3x 2.5 Zoll internen Laufwerken, TFX-Netzteil und umfangreichem tool-less Design.`,
      en: `Value-added Micro-ATX slim desktop/tower chassis with slim ODD, support for up to 3x internal 2.5 inch drives, TFX PSU, and extensive tool-less design features.`,
      es: `Chasis slim desktop/tower Micro-ATX con valor añadido, Slim ODD, soporte para hasta 3 unidades internas de 2.5 pulgadas, fuente TFX y amplio diseño tool-less.`
    },
    category: `PC Chassis`,
    application: `office`,
    specs: `Micro-ATX Slim Desktop/Tower | Slim ODD + Slim FDD + Up to 3x 2.5 Int | TFX | 4x LP`,
    images: [
      `/images/products/chenbro/pc722.jpg`,
      `/images/products/chenbro/pc722-front.jpg`,
      `/images/products/chenbro/pc722-up.jpg`,
      `/images/products/chenbro/pc722-rear.jpg`
    ],
    productUrl: `https://www.chenbro.com/de-DE/product/PCChassis`,
    datasheetUrl: `/datasheets/chenbro/pc722.pdf`,
    price: null
  }
];
